<template>
  <transition name="demo">
    <div class="toast" v-show="theToast">
      <div>
        {{msg}}
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'toast',
    data() {
      return {
        theToast: false,
        msg: ""
      };
    }
  };
</script>

<style scoped>
  .toast {
    position: fixed;
    top: 45%;
    left: 50%;
    margin-left: -30%;
    width: 60%;
    color: #fff;
    text-align: center;
    z-index: 999;
    display: flex;
    flex-direction: row;
    justify-content: center;align-items: center;
  }

  .toast > div {
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 5vw;
    font-size: 1.5rem;
    padding: 10px 20px;
  }

  @media screen and (min-width: 768px) {
    .toast {
      top: 45%;
      left: 50%;
      margin-left: -15vw;
      width: 30vw;
    }
  }

  .demo-enter-active,
  .demo-leave-active {
    transition: 0.3s ease-out;
  }

  .demo-enter {
    opacity: 0;
    transform: scale(1.2);
  }

  .demo-leave-to {
    opacity: 0;
    transform: scale(0.8);
  }
</style>



// WEBPACK FOOTER //
// src/components/toast/Toast.vue